import React from 'react';
import PropTypes from 'prop-types';
import { useStep } from './StepContext';

/**
 * Contains custom content to be render as part of the active `Step`.
 *
 * Related components: [ProgressStepper](#progressstepper), [Step](#step), [StepButton](#stepbutton),
 * [StepLabel](#steplabel).
 *
 * Usage:
 *
 * ```jsx
 * import { StepContent } from '@one-thd/sui-atomic-components';
 * ```
 */
const StepContent = ({
  children,
}) => {

  const { active } = useStep();

  if (!active) {
    return null;
  }

  return (
    <div className="sui-mt-2 sui-mb-8">
      {children}
    </div>
  );
};

StepContent.displayName = 'StepContent';

StepContent.propTypes = {
  /**
   * Custom content to be rendered as part of the active `Step` component.
   */
  children: PropTypes.node,
};

export { StepContent };